import { HeadingNumeral } from "@/components/marketplace/layout/heading-numeral"
import { Heading, Text } from "@/components/ui"
import { type ImageCrop, TileImage } from "@/components/ui/tile-image"

interface TrustBandProps {
  image: string
  imageCrop?: ImageCrop
  imageAlt: string
  eyebrow?: string
  title: string
  sub?: string
  pill?: string
}

export const TrustBand = ({ image, imageCrop, imageAlt, eyebrow, title, sub, pill }: TrustBandProps) => (
  <div className="px-gut @container">
    <div className="rounded-20x bg-brand-muted overflow-hidden">
      <div className="@2xl:aspect-panorama relative aspect-video">
        <TileImage src={image} crop={imageCrop} alt={imageAlt} fill sizes="(max-width: 768px) 100vw, 90vw" className="object-cover" />
      </div>
      <div className="flex flex-col gap-400 p-600 @2xl:p-800">
        {eyebrow && (
          <Text as="p" variant="eyebrow" tone="brand">
            {eyebrow}
          </Text>
        )}
        <Heading as="h2" variant="displaySm" family="display" tone="strong" balance className="@2xl:text-display-2xl">
          <HeadingNumeral>{title}</HeadingNumeral>
        </Heading>
        <div className="flex flex-wrap items-center gap-x-400 gap-y-300">
          {pill && (
            <Text as="span" variant="bodySm" family="text" tone="inverted" className="bg-fg-strong rounded-full px-350 py-200 font-semibold">
              {pill}
            </Text>
          )}
          {sub && (
            <Text as="p" variant="body" family="text" tone="inherit" className="text-fg-soft">
              {sub}
            </Text>
          )}
        </div>
      </div>
    </div>
  </div>
)
